var map = {
	"./black/index.js": [
		50465,
		317
	],
	"./blue/index.js": [
		50026,
		669
	],
	"./golden/index.js": [
		40447,
		769
	],
	"./green/index.js": [
		38257,
		557
	],
	"./red/index.js": [
		81069,
		125
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 41948;
module.exports = webpackAsyncContext;